<template>
  <div class="mobile">
    <router-view></router-view>
    <FooterDom></FooterDom>
  </div>
</template>

<script>
import FooterDom from "./FooterDom.vue";

export default {
  name: '',
  mixins: [],
  components: {
    FooterDom
  },
  props: {},
  data () {
    return {
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {}
}
</script>

<style scoped >

.mobile{
  width: 100%;
}
</style>
